/*
Rajesh 09/19/2022  2805568664 Fixed GAL (136,137,158,98) and field group table GAL-153
Sohel  09/22/2022  2805568664 Custom Windows Feedback Modifications
ashraf 09/24/2022  2805568664 Fixed Custom Windows Bugs
ashraf 09/25/2022  2805568664 custom window fields drag and drop bug fixes
sohel  09/26/2022  2805568664 Custom Windows -> Added Window Owner Field, columns to dashboard table bugfixes.
ashraf 09/26/2022  2805568664 change label of reset buttons to reset
ashraf 09/29/2022  2805568664 fixed style issues in custom windows
ashraf 09/29/2022  2805568664 fixed merge conflict
ashraf 09/29/2022  2805568664 fixed bugs on add custom window
yogesh 09/29/2022  2805568664 Icon Enhancement in Side Nav
aditya 09/29/2022  2805568664 Minor changes
usha   09/29/2022  2805568664 Customization in custom window
ashraf 09/30/2022  2805568664 fixed copy window issue
ashraf 09/30/2022  2805568664 fixed ssn and phone format bugs
ashraf 10/01/2022  2805568664 fixed custom window bugs
rajesh 10/01/2022  2805568664 fixed bugs in UDW
ashraf 10/06/2022  2805568664 added comments to code, removed unusual code
ashraf 10/06/2022  2805568664 fixed page break issue in role data
ashraf 10/07/2022  2805568664 removed commented code
ashraf 10/13/2022  2805568664 changed validation length for window name in custom windows
ashraf 10/15/2022  2805568664 Added custom windows code comments
suresh peddavoora 10/27/2022 2805568664  Added Class Name for Text Fields and Buttons
ashraf 10/27/2022  2805568664 custom window UX changes
suresh peddavoora 10/28/2022 2805568664  Removed Class Name for custom windows Card
Sai Maheshwar 04/11/2022 2805568664 Updated API payload
Ashraf 11/08/2022 2805568664 added field json validator
Sai Maheshwar 11/14/2022 2698811066 added formatted JSON validator from payload
lalitha 11/14/2022 2805568664 added validation in validate JSON. Increased font size.
suresh peddavoora 11/18/2022 2805568664 Modified Alignments for Text Fields.
Sai Maheshwar 11/18/2022 2698811066 removed unwanted code
Sai Maheshwar 11/04/2022 2805568664 Updated API payload
Ashraf 11/09/2022 2805568664 fetching type code dropdown
Ashraf 11/28/2022 2805568664 added repository fields mapping.
Gummala Prakash 11/28/2022 2805568664 Removed card component.
Ashraf 11/28/2022 2805568664 added mandatory field to initial values
Ashraf 11/28/2022 2805568664 fixed mandatory field to initial values
Gummala Prakash 11/29/2022 2805568664 Added Table Header.
Poornima 11/30/2022 2805568664 Passed form values as props to map fields popup
Poornima 11/30/2022 2805568664 fixed prepopulate bugs
Ashraf 11/30/2022 2805568664 Added special char validation
Ashraf 12/01/2022 2805568664 Added validation for created For
Ashraf 12/01/2022 2805568664 converting window name to uppercase.
Ashraf 12/01/2022 2805568664 added view only checkbox
Suresh Peddavoora 12/01/2022 2805568664 Fixed Button Spacing Alignment Issue
Ashraf 12/01/2022 2805568664 added duplicate window name validation
Ashraf 12/01/2022 2805568664 increased popup size
Ashraf 12/01/2022 2805568664 selecting either of mandatory or view only
Sai Maheshwar 12/04/2022 2698948956 Added map fields save close buttons
akhila 12/04/2022 2698948956 Added exit windowName dropdown
Ashraf 12/04/2022 2805568664 fixed prepopulation issue
Ashraf 12/04/2022 2805568664 fixed page break issue
Ashraf 12/04/2022 2805568664 fixed reset issue
Sai maheshwar 12/04/2022 2805568664 added unsaved changes alert
Ashraf 12/05/2022 2805568664 fixed description field validation on copy
Sai Maheshwar  12/06/2022 2805569304 fixed JSON validation.
akhila 12/07/2022  2805568664 added default value for createdFor and fixed save tooltip
Poornima 12/07/2022  2805568664 Added download  configuration buttons
Lalitha 12/09/2022  2805568664 Added reusable backButtonText
Rajesh 12/09/2022 2805568664 reset issue and back search enable
Ashraf 12/12/2022 2805568664 fixed role based access in custom windows
Ashraf 12/12/2022 2805568664 fixed toast message issue
akhila 12/13/2022  2805568664 Adding updated payload for Download Configurations
Ashraf 12/13/2022 2698811066 fixed toast msg issue when copying a window
Ashraf 12/14/2022 2805568664 fixed role based access
Ashraf 12/16/2022 2805568664 fixed loader issue
Ashraf 12/19/2022 2805568664 sfixed deleted ids bug on reset
Akhila 01/10/2023 2805568664 removed unwanted lookUp api
Sohel 02/10/2023 2805568664 window name validation changes
Sohel 02/14/2023 2805568664 Download Configurations Payload changes
Ravi 02//23/2023 2805568664 Added popup in download configuration button.
suresh peddavoora 02/24/2023 2805568664 New UI changes added
suresh peddavoora 02/24/2023 2805568664 New UI changes
suresh peddavoora 03/01/2023 2805568664 New UI changes
Ravi 03/01/2023 2805568664 Added loader and download toast message for preview File
sohel 03/06/2023 2805568664 Added validation message for existing value
Akhila 03/16/2023 2805568664 bug fixed added unsaved changes popup and toast message afetr success record save button
Sai maheshwar 03/20/2023  4136387705 added multirecord selection validation in custom window
Dilip 03/20/2023  4136387705 Added order direction field and delete id's functionality
Rohini 03/20/2023 4136387705 added classname for input fields.
Sohel 03/31/2023 4136387705 Fixed Category Dropdown value Issue
Prakash 06/04/2023 4136387705 fixed alignments issue in responsive
Prakash 10/04/2023 4136387705 fixed check box color
Sohel 04/27/2023 4136387705 Added Data Calculation Field
Prakash 28/04/2023 4136387705 fixed button spacing issue
Sohel  05/05/2023 4136387705 Added Mandatory and View only Popup
Sohel 06/01/2023 4136387705 Added module Name in payload
Ravi 06/09/2023 4136387705 Added Breadcrums in preview
Ravi 06/20/2023 4136387705 Added Breadcrums in popup
Ravi 06/26/2023 4136387705 fixed submit issue
Ravi 06/26/2023 4136387705 fixed submit disable issue
Sohel 10/02/2023 4136387705 Fixed Dialogue Header name Issue
Sohel 10/06/2023 4136387705 Changed Window Name Validation
Sohel 10/07/2023 4136387705 existing repo name search dropdown bug fix
Sohel 10/10/2023 2805568664 Add field based on repository name and field name
vSohel 10/25/2023 2805568664 Fixed Mandatory and View Only Validation Toast issue
Gireesh 12/11/2023 2805568664  Added validation for window name in custom windows
Gireesh 12/12/2023 2805568664  removed validation for window name in custom windows
*/

import React, {useState, useEffect, useContext, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {Formik} from 'formik';
import * as Yup from 'yup';

import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  TextField,
  Tooltip,
  MenuItem,
  InputLabel,
  Select,
} from '@material-ui/core';
import {ThemeContext} from '../../themes/ThemeProvider';
import ErrorBoundaryForComponents from '../../util/ErrorBoundaryForComponents';
import {ErrorSnackbar, SuccessSnackbar} from '../../components/CustomSnackBar';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import {getFields} from './Components/SearchFieldsTable';
import {
  resetUdwStatus,
  // fetchLookupValues,
  fetchTypeCodeData,
  postRepoFieldsUDW,
  resetToast,
  fetchwindowNameData,
} from '../../redux/reducers/UserDefinedWindow';
import {ArrowBack} from '@material-ui/icons';
import DialogBox from '../DialogBox';
import SearchDataRepositoryFields from './Components/SearchDataRepositoryFields';
import FieldTable from './RepoFieldsTable';
import {getBaseCategory} from '../../redux/reducers/GlobalField/AddFieldList';
import {reportMasterUserName} from '../../redux/reducers/BRE/AddReportMaster';
import PageLoader from '../PageLoader';
import useUnsavedChangesWarning from '../../util/CustomHooks';
import {setAlertData} from '../../redux/reducers/UnsavedChangesAlertReducer';
import {backButtonText, downloadButton} from '../../util/Content';
import {
  postCustomWindows,
  resetUDWPrintStatus,
  resetConfigUrl,
  resetDockey,
} from '../../redux/reducers/UDW/UDWlookup';
import GuiAutoComplete from '../FormComponents/GuiAutoComplete';
import GuiTextField from '../FormComponents/GuiTextField';
import PreviewFileDialog from '../../util/PreviewFileDialog';
import axios from 'axios';
import {resetDownloadMsg} from '../../redux/reducers/PreviewFileData';
import DialogeSuccesMsg from './DialogeSuccesMsg';
import AddIcon from '@material-ui/icons/Add';
import SearchLogicField from '../../Pages/FrameWorks/DataManager/DataManagerRecord/AddDataManagerRecord/SearchLogicField';
import BreadCrums from '../../util/BreadCrum';
import {createForOptions} from '../../util/CreatedByForOptions';
import {submissionStart} from '../../redux/reducers/CommonActions/commonActions';
const orderOptions = [
  {label: 'Ascending', value: 'asc'},
  {label: 'Descending', value: 'des'},
];
const MaintainUserDefined = ({
  setUDWData,
  UDWData,
  windowNumber,
  windowsData,
  isCopyRowData,
  setWindowNumber,
  setIsCopyRowData,
  editExisting,
  setEditExisting,
  initialValues,
  setInitialValues,
  changedWindowNumber,
  setFormData,
  formData,
  editable,
  setEditable,
  setValue,
}) => {
  const dispatch = useDispatch();
  const [deleted, setDeleted] = useState([]);
  const [deletedFields, setDeletedFields] = useState({});
  const {roleData} = useSelector(({role}) => role);
  const [logicFieldsOpen, setLogicFieldsOpen] = useState(false);
  // const [isJsonValid, setIsJsonValid] = useState(true)
  const [mapFiledsDialog, setMapFieldListDialog] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [multiRecordData, setMultiRecordData] = useState([]);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [deletedRules, setDeletedRules] = useState([]);
  const [nameData, setNameData] = useState();
  const [namePopover, setNamePopover] = useState(false);
  const showAlertRef = useRef(false);
  const {routerPrompt, onDirty, onPristine} = useUnsavedChangesWarning();
  const [configOpen, setConfigOpen] = useState(false);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [saveOpen, setSaveOpen] = useState(false);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  useEffect(() => {
    dispatch(fetchTypeCodeData());
    dispatch(reportMasterUserName());
    dispatch(fetchwindowNameData());
  }, []);

  const formRef = useRef();
  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const {
    udwData,
    udwStatus,
    errorMsg,
    successMsg: deleteSuccess,
    customWindowData,
    allWindowData,
    isLoading,
  } = useSelector(({userDefinedWindow}) => userDefinedWindow);

  const roleAccess = !roleData?.window?.['Custom Window']?.[customWindowData?.windowName]?.read;

  const {configurationUrl, dockey} = useSelector(
    ({udwLookup}) => udwLookup,
  );
  const {successMsg, lookupUDWerrorMsg, WindowStatus} = useSelector(({udwLookup}) => udwLookup);

  const {userNameData} = useSelector(({addReportMaster}) => addReportMaster);
  const [reset, setReset] = useState(false);
  const handleSaveClose = () => {
    setSaveOpen(false);
  };
  const handleLogicFieldsClose = () => {
    setLogicFieldsOpen(false);
  };
  // handling deleted fields for existing window (2699242124)
  useEffect(() => {
    let v = [];
    if (deleted.length > 0) {
      v = [...deleted, deletedFields];
    } else if (Object.keys(deletedFields)?.length > 0) {
      v = [deletedFields];
    }
    if (v.length > 0) {
      setDeleted(v);
    }
  }, [deletedFields]);

  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);

  // setting initial values to null, when window number is null (2699242124)
  // useEffect(() => {
  //   if (windowNumber === null) {
  //     setInitialValues({
  //       type: "none",
  //       windowCode: "",
  //       description: "",
  //       viewOnly: false,
  //       header: "",
  //       indicator: "",
  //       windowOwner: "",
  //       jsonValidator: "",
  //       createdFor: "",
  //       category: "",
  //       fieldHeader: "",
  //       viewOnlyField: "",
  //     });
  //   }
  // }, [windowNumber]);

  // setting fields table data when copying a window (2699242124)
  useEffect(() => {
    if (
      windowNumber &&
      isCopyRowData &&
      udwData &&
      Object.keys(udwData).length > 0 &&
      udwData?.[windowNumber]?.fields
    ) {
      const data = udwData?.[windowNumber]?.fields?.map((o, i) => ({
        windowFieldId: null,
        sequenceNo: isCopyRowData ? i + 1 : o?.sequenceNo,
        fieldLabel: o?.fieldLabel,
        fieldType: o?.fieldType,
        validationType: o?.validationType ? o?.validationType : null,
        lookupType: isCopyRowData ? '' : o?.lookupType ? o?.lookupType : '',
        isLookUp: o?.isLookUp ? o?.isLookUp : '',
        isActive: 'Y',
        isList: o?.isList,
        listValue: o?.isList === 'Dropdown' ? '' : o?.listValue ? o?.listValue : '',
        isMandatory: o?.isMandatory,
        validations: o?.validations,
        globalFieldName: o?.globalFieldName,
        typeCode: o?.isList === 'Dropdown' ? o?.listValue.toString() : '',
        maximumLength: o?.maximumLength ? o?.maximumLength : '',
        minimumLength: o?.minimumLength ? o?.minimumLength : '',
        displayOptions: {
          isExtended: o?.isExtended,
          isEditable: o?.isEditable,
          isUnique: o?.isUnique,
          isHidden: o?.isHidden,
        },
        additionalOptions: {
          isAuditNote: isCopyRowData ? 'N' : o?.isAuditNote,
          isAuditTrail: isCopyRowData ? 'N' : o?.isAuditTrail,
          isTrackChanges: o?.isTrackChanges,
        },
      }));
      setFormData(data?.length > 0 ? data : []);
    } else {
      setFormData([]);
    }
  }, [udwData, isCopyRowData, reset]);
  // resetting all data after saving successfully (2699242124)
  useEffect(() => {
    if (udwStatus === 200) {
      setWindowNumber(null);
      setFormData([]);
      setEditable([]);
      setDeletedFields({});
      setDeleted([]);
      setEditExisting(false);
      if (roleAccess || isCopyRowData) {
        setSaveOpen(true);
      }
      // dispatch(fetchLookupValues());
      formRef?.current?.resetForm();
      setSelectedRows([]);
      // let timeOut = roleAccess || isCopyRowData ? 7000 : 3000;
      if (!roleAccess) {
        setTimeout(() => {
          setIsCopyRowData(false);
          dispatch(resetUdwStatus());
          dispatch(resetToast());
          setValue(0);
        }, 3000);
      }
    }
  }, [udwStatus]);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 2500);
    }
  }, [errorMsg]);

  // taking existing window names for field level validation (2699242124)
  // const windowNameValidation = () => {
  //   return allWindowData && allWindowData?.length > 0 && allWindowData?.map((i) => i?.windowName);
  // };
  const windowNameValidation = () => {
    return allWindowData?.length > 0 ? allWindowData : [];
  };

  // check window name already exist (2699242124)
  const getWindowNameVal = (data, val) => {
    const v = val && val;
    const windowNameData =
      data &&
      data?.length > 0 &&
      data?.filter((item) => {
        return item?.windowName?.toLowerCase() === v?.toLowerCase();
      });
    let res = false;
    if (
      windowNameData?.length > 0 &&
      windowNameData[0]?.windowName?.toLowerCase() === v?.toLowerCase() &&
      windowNameData[0]?.isActive === 'Y'
    ) {
      res = true;
    } else {
      res = false;
    }
    return res;
  };
  const getWindowNameAlreadyVal = (data, val) => {
    const v = val && val;
    const windowNameData =
      data &&
      data?.length > 0 &&
      data?.filter((item) => {
        return item?.windowName?.toLowerCase() === v?.toLowerCase();
      });
    let res = false;
    if (
      windowNameData?.length > 0 &&
      windowNameData[0]?.windowName?.toLowerCase() === v?.toLowerCase() &&
      windowNameData[0]?.isActive === 'N'
    ) {
      res = true;
    } else {
      res = false;
    }
    return res;
  };
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const {baseCategoryData} = useSelector(({addFieldList}) => addFieldList);

  const [baseValue, setBaseValue] = useState('');

  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  // setting initial values of form for window number change or copying a window (2699242124)
  useEffect(() => {
    if (customWindowData && Object.keys(customWindowData).length > 0) {
      setBaseValue(
        customWindowData?.category ?
          getCategoryObject(customWindowData?.category, baseCategoryData) :
          '',
      );
      const obj = {
        category: customWindowData?.category ?
          getCategoryObject(customWindowData?.category, baseCategoryData) :
          '',
        jsonValidator: isCopyRowData ? '' : customWindowData?.jsonValidator,
        header: isCopyRowData ?
          '' :
          customWindowData?.windowName ?
            customWindowData?.windowName :
            '',
        indicator: isCopyRowData ?
          '' :
          customWindowData?.windowIndicator ?
            customWindowData?.windowIndicator :
            '',
        description: isCopyRowData ?
          '' :
          customWindowData?.windowDescription ?
            customWindowData?.windowDescription :
            '',
        createdFor: isCopyRowData ?
          {userLoginName: user?.userName} :
          customWindowData?.createdFor ?
            getCategoryObject(customWindowData?.createdFor, userNameData) :
            {userLoginName: user?.userName},
        viewOnly: customWindowData?.viewOnly === 'Y',
        orderBy: customWindowData?.orderBy?.length > 0 ? customWindowData?.orderBy[0] : {},
        groupBy: customWindowData?.groupBy?.length > 0 ? customWindowData?.groupBy[0] : {},
        orderDirection: customWindowData?.orderDirection || 'asc',
      };
      const values = {};
      customWindowData?.dataRepositoryFields &&
        customWindowData?.dataRepositoryFields?.map((r) => {
          values['fieldHeader' + r.repositoryName + r.fieldName] =
            values['fieldHeader' + r.repositoryName + r.fieldName] || r.fieldLabel;

          values['viewOnlyField' + r.repositoryName + r.fieldName] =
            values['viewOnlyField' + r.repositoryName + r.fieldName] || r.isView;

          values['mandatoryField' + r.repositoryName + r.fieldName] =
            values['mandatoryField' + r.repositoryName + r.fieldName] || r.isMandatory;
        });
      const objs = {...obj, ...values};
      setInitialValues(objs);
      // setInitialValues({
      // type:
      //   udwData?.[windowNumber]?.window?.type &&
      //   getObject(udwData?.[windowNumber]?.window?.type, typeOptions),
      // windowCode: isCopyRowData ? "" : udwData?.[windowNumber]?.window?.windowCode,
      // description: isCopyRowData ? "" : udwData?.[windowNumber]?.window?.description,
      // viewOnly: udwData?.[windowNumber]?.window?.isView === "Y",
      // header: isCopyRowData ? "" : udwData?.[windowNumber]?.window?.header,
      // indicator: isCopyRowData ? "" : udwData?.[windowNumber]?.window?.indicator,
      // dbTableView: isCopyRowData ? "" : udwData?.[windowNumber]?.window?.dbTableView,
      // windowOwner: isCopyRowData
      //   ? ""
      //   : udwData?.[windowNumber]?.window?.windowOwner
      //     ? udwData?.[windowNumber]?.window?.windowOwner
      //     : "",
      // createdFor: isCopyRowData ? "" : udwData?.[windowNumber]?.window?.createdFor,
      // });
    }
  }, [isCopyRowData, customWindowData, reset, baseCategoryData, userNameData]);

  const shape = {};
  selectedRows?.forEach((r, i) => {
    const currField = r.repositoryName + r.fieldName;
    shape['fieldHeader' + currField] = Yup.string()
      .nullable()
      .required('Field Label is required')
      .test(
        'fieldHeader' + currField,
        (path) => {
          return 'Field Label ' + path.value + ' is already defined';
        },
        function(value) {
          const fieldHeaders = selectedRows?.map((i) => {
            if (i.repositoryName + i.fieldName !== r.repositoryName + r.fieldName) {
              return formRef?.current?.values[
                'fieldHeader' + i.repositoryName + i.fieldName
              ]?.trim();
            }
          });
          if (value && fieldHeaders?.includes(value?.trim())) {
            return false;
          } else {
            return true;
          }
        },
      );
  });
  useEffect(() => {
    if (selectedRows?.length > 0) {
      const newData = selectedRows?.filter((i) => i?.multiRecord === 'Y');
      setMultiRecordData(newData);
    }
  }, [selectedRows]);
  // validation for window form fields (2699242124)
  const schema = Yup.object().shape({
    ...shape,
    category: Yup.mixed().test('category', 'Category is required', (value) => {
      if (!value?.categoryName) {
        return false;
      } else {
        return true;
      }
    }),
    description: Yup.string()
      .required('Window Description is required'),
    // windowOwner:
    //   (!windowNumber || isCopyRowData) && Yup.string().required("Window Owner is required"),
    // windowCode:
    //   (!windowNumber || isCopyRowData) &&
    //   Yup.string()
    //     .test("windowCode", "Window Code already exists", function(val) {
    //       if (getWindowCodeVal(windowCodeValidation(), val)) {
    //         return false;
    //       } else {
    //         return true;
    //       }
    //     })
    //     .required("Window code is required")
    //     .min(3, "Window code cannot be less than 3 digits")
    //     .max(4, "Window code cannot exceed 4 digits"),
    header:
      (isCopyRowData || !customWindowData?.windowId) &&
      Yup.string()
        .test('header', 'Window Name already in use', function(val) {
          if (getWindowNameVal(windowNameValidation(), val)) {
            return false;
          } else {
            return true;
          }
        })
        .test('header', 'Window Name has already been used in the past', function(val) {
          if (getWindowNameAlreadyVal(windowNameValidation(), val)) {
            return false;
          } else {
            return true;
          }
        })
        .required('Window Name is required'),
    // .matches(/^[a-zA-Z0-9\_]+$/, "Only alphabets, numbers and underscore(_) are allowed"),
    createdFor: Yup.mixed().test('createdFor', 'Created For is required', function(val) {
      if (!val?.userLoginName) {
        return false;
      } else {
        return true;
      }
    }),
    // jsonValidator: Yup.string().test("jsonValidator", "Invalid Json", (value) => {
    //   let valid = true;
    //   try {
    //     JSON.parse(value);
    //   } catch (err) {
    //     valid = false;
    //   }
    //   return valid;
    // }),
  });

  window.onclick = function() {
    setNamePopover(false);
  };

  const handleClose = () => {
    setMapFieldListDialog(false);
  };
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  const getCategoryObject = (value, data) => {
    const category =
      data &&
      data?.filter((i) => {
        if (i?.categoryCode) {
          return i?.categoryCode === value;
        } else if (i?.userLoginName) {
          return i?.userLoginName === value;
        }
      });
    if (category?.length > 0) {
      return category[0];
    }
  };
  const filteredCategory = baseCategoryData?.filter((item) => item?.categoryCode !== 'AR');

  useEffect(() => {
    dispatch(getBaseCategory());
  }, []);

  // useEffect(() => {
  //   let values = {};

  //   selectedRows?.forEach((r, i) => {
  //     values["fieldHeader" + r.fieldName] = formRef?.current?.values["fieldHeader" + r.fieldName] || r.fieldLabel;

  //     values["viewOnlyField" + r.fieldName] = formRef?.current?.values["viewOnlyField" + r.fieldName] || r.viewOnly || r.isView;

  //     values["mandatoryField" + r.fieldName] =
  //         formRef?.current?.values["mandatoryField" + r.fieldName] || r.isMandatory;
  //   });

  //   let obj = {
  //     category: formRef?.current?.values?.category?.categoryCode
  //       ? getCategoryObject(formRef?.current?.values?.category?.categoryCode, baseCategoryData)
  //       : isCopyRowData
  //         ? ""
  //         : customWindowData?.category
  //           ? getCategoryObject(customWindowData?.category, baseCategoryData)
  //           : "",
  //     header: formRef?.current?.values?.header
  //       ? formRef?.current?.values?.header
  //       : isCopyRowData
  //         ? ""
  //         : customWindowData?.windowName
  //           ? customWindowData?.windowName
  //           : "",
  //     description: isCopyRowData
  //       ? ""
  //       : customWindowData?.windowDescription
  //         ? customWindowData?.windowDescription
  //         : formRef?.current?.values?.description
  //           ? formRef?.current?.values?.description
  //           : "",
  //     createdFor: formRef?.current?.values?.createdFor?.userName
  //       ? getCategoryObject(formRef?.current?.values?.createdFor?.userName, userNameData)
  //       : isCopyRowData
  //         ? ""
  //         : customWindowData?.createdFor
  //           ? getCategoryObject(customWindowData?.createdFor, userNameData)
  //           : "",
  //     indicator: formRef?.current?.values?.indicator
  //       ? formRef?.current?.values?.indicator
  //       : isCopyRowData
  //         ? ""
  //         : customWindowData?.windowIndicator
  //           ? customWindowData?.windowIndicator
  //           : "",
  //     viewOnly:
  //       formRef?.current?.values?.viewOnly === "Y" ? true : customWindowData?.viewOnly === "Y",
  //   };
  //   let ar = { ...obj, ...values };
  //   setInitialValues((pre) => ({...pre, ...ar}));
  // }, [selectedRows]);
  useEffect(() => {
    if (WindowStatus && WindowStatus === 200) {
      setTimeout(() => {
        dispatch(resetUDWPrintStatus());
      }, 3000);
    }
  }, [WindowStatus]);
  useEffect(() => {
    if (customWindowData && customWindowData?.dataRepositoryFields?.length > 0) {
      let elements = [];
      elements = customWindowData?.dataRepositoryFields.map((ele) => {
        const obj = {
          ...ele,
          ...getFields(ele),
          mapFieldType: ele?.type,
          tableData: {checked: true, id: ele.fieldName},
        };
        return obj;
      });

      const uniqueArray = elements.filter(
        (value, index, self) => index === self.findIndex((t) => t.fieldName === value.fieldName),
      );
      setSelectedRows(uniqueArray);
    }
  }, [customWindowData?.dataRepositoryFields, reset]);

  const submit = (values) => {
    dispatch(submissionStart());
    const repoFields = selectedRows.map((r, i) => {
      const field = {};
      field['seqNo'] = i + 1;
      field['fieldLabel'] = values['fieldHeader' + r.repositoryName + r.fieldName];
      field['isView'] = values?.viewOnly ?
        'Y' :
        values['viewOnlyField' + r.repositoryName + r.fieldName] ?
          values['viewOnlyField' + r.repositoryName + r.fieldName] :
          '';
      field['isMandatory'] = values?.viewOnly ?
        'N' :
        values['mandatoryField' + r.repositoryName + r.fieldName];
      field['fieldId'] = isCopyRowData ? 0 : r?.fieldId ? r?.fieldId : 0;
      field['windowName'] = values?.header;
      field['fieldName'] = r.fieldName;
      field['repositoryName'] = r.repositoryName;
      field['multiRecord'] = r?.multiRecord || 'N';
      field['fieldType'] = r?.fieldType || r?.dataType;
      if(["Data Calculation Field","DATA CALCULATION FIELD"]?.includes(r?.mapFieldType)){
        field['repositoryId'] = null;
        field['mapFieldId'] = r?.dataCalculationId || r?.mapFieldId || 0
        field['type'] = "DATA CALCULATION FIELD"
      }else{
        field['repositoryId'] = r?.dataRepositoryId || r?.repositoryId || null;
        field['mapFieldId'] = r?.repositoryFieldId  || r?.mapFieldId || 0
        field['type'] = "DB FIELD"
      }
      return field;
    });

    const obj = {};
    const obj2 = {};
    // const orderAndGroupFields = [...customWindowData?.groupBy, ...customWindowData.orderBy];
    customWindowData?.groupBy?.forEach((row) => {
      obj[row?.repositoryName + row?.fieldName] = row?.customWindowOrderId;
    });
    customWindowData?.orderBy?.forEach((row) => {
      obj2[row?.repositoryName + row?.fieldName] = row?.customWindowOrderId;
    });
    [values?.groupBy]?.forEach((row2) => {
      if (obj[row2?.repositoryName + row2?.fieldName]) {
        delete obj[row2?.repositoryName + row2?.fieldName];
      }
    });
    [values?.orderBy]?.forEach((row2) => {
      if (obj2[row2?.repositoryName + row2?.fieldName]) {
        delete obj2[row2?.repositoryName + row2?.fieldName];
      }
    });
    const getOrderAndGroupBy = (data, field) => {
      const newData = data?.map((ele) => {
        const existingId = customWindowData?.[field]?.filter((el) => {
          return el.repositoryName + el.fieldName === ele.repositoryName + ele.fieldName;
        });
        const obj = {
          fieldLabel: ele.fieldLabel,
          fieldName: ele.fieldName,
          repositoryName: ele.repositoryName,
          fieldType: ele.fieldType,
          repositoryId: ele?.dataRepositoryId || ele?.repositoryId || 0,
          mapFieldId: ele?.repositoryFieldId || ele?.mapFieldId || 0,
          customWindowOrderId: existingId?.[0]?.customWindowOrderId || 0,
        };
        return obj;
      });
      return newData;
    };
    const payload = {
      windowDescription: values?.description,
      windowIndicator: values?.indicator ? values?.indicator : '',
      jsonValidator: values?.jsonValidator,
      windowId: isCopyRowData ? 0 : customWindowData?.windowId ? customWindowData?.windowId : 0,
      windowName: values?.header,
      category: values?.category?.categoryCode,
      createdFor: values?.createdFor?.userLoginName,
      viewOnly: values?.viewOnly ? 'Y' : 'N',
      dataRepositoryFields: repoFields?.length > 0 ? repoFields : [],
      deletedFieldsId: isCopyRowData ? [] : deletedRules?.length > 0 ? deletedRules : [],
      deletedGroupByOrderByIds:
        Object.values(obj) || Object.values(obj2) ?
          [...Object.values(obj), ...Object.values(obj2)] :
          [],
      orderBy:
        multiRecordData?.length > 1 && values?.orderBy && Object.keys(values?.orderBy)?.length > 0 ?
          getOrderAndGroupBy([values?.orderBy], 'orderBy') :
          [],
      groupBy:
        multiRecordData?.length > 1 && values?.groupBy && Object.keys(values?.groupBy)?.length > 0 ?
          getOrderAndGroupBy([values?.groupBy], 'groupBy') :
          [],
      orderDirection: values?.orderDirection || 'asc',
    };
    dispatch(postRepoFieldsUDW(payload));
  };
  const getWindowNameData = () => {
    if (allWindowData && allWindowData?.length > 0) {
      return allWindowData?.filter((i) =>
        String(i?.windowName?.toLowerCase())?.startsWith(nameData?.toLowerCase()),
      );
    } else {
      return [];
    }
  };
  // handling download of windows data (2698948956)
  const handlePrintData = () => {
    const data = customWindowData;
    dispatch(
      postCustomWindows({
        category: data?.category ? data?.category : '',
        createdBy: '',
        createdDate: '',
        createdFor: data?.createdFor ? data?.createdFor : '',
        orderBy: '',
        orderDirection: '',
        windowDescription: data?.windowDescription ? data?.windowDescription : '',
        windowIndicator: data?.windowIndicator ? data?.windowIndicator : '',
        windowName: data?.windowName ? data?.windowName : '',
        printIndividual: 'Y',
      }),
    );
    setIsLoadingPrint(false);
  };
  return (
    <>
      <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          disabled={isLoading}
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setValue(0);
                  },
                }),
              );
            } else {
              setValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
        {customWindowData?.windowName && (
          <Button
            type="button"
            variant="outlined"
            className={`mx-1 search-btn`}
            // disabled={Boolean(dataCount === 0)}
            // tooltip: "Print",
            // isFreeAction: true,
            onClick={() => {
              handlePrintData(), setIsLoadingPrint(true);
            }}
          >
            {downloadButton}
          </Button>
        )}
      </div>
      <Formik
        onSubmit={(values, {resetForm}) => {
          submit(values);
        }}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
        innerRef={formRef}
      >
        {(props) => {
          const {
            values,
            handleChange,
            handleSubmit,
            handleReset,
            handleBlur,
            setFieldValue,
            touched,
            errors,
            dirty,
            setFieldTouched,
            isSubmitting,
          } = props;
          // handleDirty(dirty);
          useEffect(() => {
            if (dirty === true) {
              handleDirty(true);
            } else {
              handleDirty(false, 'reset');
            }
          }, [dirty]);

          return (
            <div>
              {routerPrompt}
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div className="form-row global-field-textfields new-standard-textfields">
                  <ErrorBoundaryForComponents>
                    <Grid container spacing={2}>
                      <Grid item xs={4} className="form-group autocomplete-field">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                            popper: classes.popper,
                          }}
                          name="category"
                          // disabled={category}
                          id="category"
                          size="small"
                          value={values.category}
                          disabled={customWindowData?.windowId}
                          options={filteredCategory}
                          getOptionLabel={(option) => {
                            return option && option.categoryName ?
                              option.categoryCode === null ?
                                option.categoryName :
                                option.categoryCode + ' - ' + option.categoryName :
                              '';
                          }}
                          onChange={(e, value) => {
                            if (value) {
                              setFieldValue('category', value);
                              setBaseValue(value);
                              // setSelected(false);
                            } else {
                              setFieldValue('category', '');
                              setBaseValue('');
                              // setSelected(true);
                            }
                          }}
                          placeholder="Select Category"
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                error={touched.category && errors.category}
                                variant="outlined"
                                margin="dense"
                                required
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                label="Category"
                                placeholder="Select Category"
                              />
                            </div>
                          )}
                        />
                        <FormHelperText style={{color: 'red'}} variant="outlined">
                          {touched.category && errors.category}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={4} className="form-group">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Window Name`}
                          label="Window Name"
                          className={` ${classes.labelName}`}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          disabled={!isCopyRowData && customWindowData?.windowId}
                          name="header"
                          inputProps={{maxLength: 50}}
                          value={values?.header}
                          required
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue('header', e?.target?.value);
                            if (e.target.value) {
                              setNamePopover(true);
                              setNameData(e?.target?.value);
                            } else if (e.target.value === '') {
                              setNamePopover(false);
                            }
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.header}
                          error={Boolean(touched.header && errors.header)}
                        />
                        <FormHelperText>
                          {touched.header && errors.header && errors.header}
                        </FormHelperText>
                        <Grid item xs={6} className=" windowcode-popover form-group">
                          {namePopover &&
                            getWindowNameData()?.map((data, i) => (
                              <MenuItem key={i}>{data?.windowName?.replace(/ /g, '\u00a0')}</MenuItem>
                            ))}
                        </Grid>
                      </Grid>
                      <Grid item xs={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Window Description`}
                          label="Window Description"
                          // className={` ${classes.labelName}`}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="description"
                          value={values.description}
                          required
                          onChange={handleChange}
                          inputProps={{maxLength: 100}}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.description}
                          error={Boolean(touched.description && errors.description)}
                        />
                        <FormHelperText>
                          {touched.description && errors.description && errors.description}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={4} className="form-group autocomplete-field">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                            popper: classes.popper,
                          }}
                          name="createdFor"
                          // disabled={category}
                          id="createdFor"
                          size="small"
                          value={values.createdFor}
                          options={userNameData?.length > 0 ? userNameData : []}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createForOptions(option);
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('createdFor', value);
                          }}
                          placeholder="Select created For"
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                error={touched.createdFor && errors.createdFor}
                                variant="outlined"
                                margin="dense"
                                required
                                limitTags={1}
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                label="Created For"
                                placeholder="Select Created For"
                              />
                            </div>
                          )}
                        />
                        <FormHelperText style={{color: 'red'}} variant="outlined">
                          {touched.createdFor && errors.createdFor}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={4}>
                        <FormControl margin="dense">
                          <FormControlLabel
                            className={`${classes.checkRoot} global-fields-checkbox view-label`}
                            control={
                              <Checkbox
                                onChange={handleChange}
                                name="viewOnly"
                                checked={values.viewOnly}
                              />
                            }
                            label="View Only"
                            labelPlacement="end"
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </ErrorBoundaryForComponents>
                </div>

                {/* <FormBuilder
                  udwView={values.viewOnly}
                  UDWData={UDWData}
                  formData={formData}
                  adduser-password-fields
                  setFormData={setFormData}
                  windowNumber={windowNumber}
                  isCopyRowData={isCopyRowData}
                  editable={editable}
                  reset={reset}
                  changedWindowNumber={changedWindowNumber}
                  setEditable={setEditable}
                  setDeletedFields={setDeletedFields}
                  deletedFields={deletedFields}
                  editExisting={editExisting}
                  setDeleted={setDeleted}
                  initialValues={initialValues}
                  setEditExisting={setEditExisting}
                  deleted={deleted}
                  dirty={dirty}
                /> */}
                {isLoading && <PageLoader />}
                <div className="table-header table-card-header justify-content-end new-standard-textfields">
                  <Button
                    variant="outlined"
                    className={`search-btn mx-1 ${classes.buttonRoot} `}
                    onClick={() => setLogicFieldsOpen(true)}
                    disabled={
                      !baseValue?.categoryCode ||
                      (customWindowData?.windowId &&
                        !isCopyRowData &&
                        !roleData?.window?.['Custom Window Setup']?.CWS?.edit)
                    }
                    startIcon={<AddIcon />}
                  >
                    Data Calculations Fields
                  </Button>
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot}`}
                    onClick={() => setMapFieldListDialog(true)}
                    startIcon={<AccountTreeIcon />}
                    disabled={
                      !baseValue?.categoryCode ||
                      (customWindowData?.windowId &&
                        !isCopyRowData &&
                        !roleData?.window?.['Custom Window Setup']?.CWS?.edit)
                    }
                  >
                    Map Fields
                  </Button>
                </div>
                <FieldTable
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  // setFieldListApiData={setFieldListApiData}
                  // fieldListApiData={fieldListApiData}
                  errors={errors}
                  touched={touched}
                  values={values}
                  setFieldValue={setFieldValue}
                  inputFieldValues={initialValues}
                  setInputFieldValues={setInitialValues}
                  handleChange={handleChange}
                  deletedRules={deletedRules}
                  setDeletedRules={setDeletedRules}
                  isCopyRowData={isCopyRowData}
                  handleDirty={handleDirty}
                  setFieldTouched={setFieldTouched}
                  isSubmitting={isSubmitting}
                  // fixedlength={fixedlength}
                />
                {multiRecordData?.length > 1 ? (
                  <Grid container spacing={4} className={'mt-4 new-standard-textfields'}>
                    <Grid
                      item={true}
                      xs={5}
                      md={6}
                      lg={4}
                      className={` form-group ${
                        values?.groupBy?.length > 4 && 'autocomplete-checkbox'
                      }`}
                    >
                      {/* <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        multiple
                        disableCloseOnSelect
                        name="groupBy"
                        id="groupBy"
                        size="small"
                        value={values.groupBy}
                        options={multiRecordData || []}
                        getOptionSelected={(option, value) => {
                          return option?.fieldLabel === value?.fieldLabel;
                        }}
                        getOptionLabel={(option) => {
                          return option && option.fieldLabel ? option.fieldLabel : option;
                        }}
                        onChange={(e, value) => {
                          if (value) {
                            setFieldValue("groupBy", value);
                          } else {
                            setFieldValue("groupBy", "");
                          }
                        }}
                        renderOption={(option, { selected }) => (
                          <React.Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={
                                <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                              }
                              checked={selected}
                              className={classes.checkBox}
                            />

                            {option?.fieldLabel ? option.fieldLabel : ""}
                          </React.Fragment>
                        )}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              variant="outlined"
                              margin="dense"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Group By"
                              placeholder="Select Group By"
                              touched={touched.groupBy}
                              error={Boolean(touched.groupBy && errors.groupBy)}
                            />
                          </div>
                        )}
                      /> */}
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                          popper: classes.popper,
                        }}
                        name="groupBy"
                        id="groupBy"
                        size="small"
                        value={values.groupBy}
                        options={multiRecordData || []}
                        getOptionLabel={(option) => {
                          return option && option?.fieldLabel ? option?.fieldLabel : '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('groupBy', value);
                        }}
                        placeholder="Select created For"
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              error={touched.groupBy && errors.groupBy}
                              variant="outlined"
                              margin="dense"
                              className={` ${classes.labelName}`}
                              label="Group By"
                              placeholder="Select Group By"
                            />
                          </div>
                        )}
                      />
                    </Grid>
                    <Grid
                      item={true}
                      xs={5}
                      md={6}
                      lg={4}
                      className={` form-group ${
                        values?.orderBy?.length > 4 && 'autocomplete-checkbox'
                      }`}
                    >
                      {/* <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        multiple
                        disableCloseOnSelect
                        name="orderBy"
                        id="orderBy"
                        size="small"
                        value={values.orderBy}
                        options={multiRecordData || []}
                        getOptionSelected={(option, value) => {
                          return option?.fieldLabel === value?.fieldLabel;
                        }}
                        getOptionLabel={(option) => {
                          return option && option.fieldLabel ? option.fieldLabel : option;
                        }}
                        onChange={(e, value) => {
                          if (value) {
                            setFieldValue("orderBy", value);
                          } else {
                            setFieldValue("orderBy", "");
                          }
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              error={touched.orderBy && errors.orderBy}
                              variant="outlined"
                              margin="dense"
                              className={` ${classes.labelName}`}
                              label="Order By"
                              placeholder="Select Order By"
                            />

                            {option?.fieldLabel ? option.fieldLabel : ""}
                          </React.Fragment>
                        )}
                      /> */}
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                          popper: classes.popper,
                        }}
                        name="orderBy"
                        id="orderBy"
                        size="small"
                        value={values.orderBy}
                        options={multiRecordData || []}
                        getOptionLabel={(option) => {
                          return option && option?.fieldLabel ? option?.fieldLabel : '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('orderBy', value);
                        }}
                        placeholder="Select created For"
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              error={touched.orderBy && errors.orderBy}
                              variant="outlined"
                              margin="dense"
                              className={` ${classes.labelName}`}
                              label="Order By"
                              placeholder="Select Order By"
                            />
                          </div>
                        )}
                      />
                    </Grid>
                    <Grid item xs={4} md={6} lg={4} className=" form-group custom-window-fields">
                      <FormControl margin="dense" variant="outlined" fullWidth>
                        <InputLabel error={errors.category} required>
                          Order Direction
                        </InputLabel>
                        <Select
                          fullWidth
                          name="orderDirection"
                          className={`select-gender ${classes.labelName}`}
                          label="Category"
                          required
                          value={values.orderDirection || 'asc'}
                          onChange={(event) => {
                            setFieldValue('orderDirection', event.target.value);
                          }}
                          onBlur={handleBlur}
                          touched={touched.orderDirection}
                        >
                          {orderOptions.map((option) => {
                            return (
                              <MenuItem value={option.value} key={option.value}>
                                {option.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                ) : null}

                <div className="global-field-textfields  new-standard-textfields mt-4">
                  <Grid container spacing={2}>
                    <Grid item xs={12} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        multiline
                        minRows={4}
                        maxRows={4}
                        placeholder={`Enter data to validate`}
                        label="Validate JSON"
                        // className={`${classes.inputLabel}`}
                        className={` ${classes.labelName}`}
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        inputProps={{style: {fontSize: 20}}}
                        name="jsonValidator"
                        value={values.jsonValidator}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.jsonValidator}
                        error={Boolean(touched.jsonValidator && errors.jsonValidator)}
                      />
                      {/* <FormHelperText>
                        {isJsonValid ? null : "JSON is not valid"}
                      </FormHelperText> */}
                    </Grid>
                  </Grid>
                </div>
                <div className="d-flex justify-content-center new-standard-textfields">
                  <Button
                    type="reset"
                    variant="outlined"
                    className={`reset-btn mr-2 ${classes.buttonRoot}`}
                    onClick={() => {
                      if (!customWindowData?.windowId) {
                        setBaseValue('');
                        setFormData([]);
                        setDeletedRules([]);
                        setSelectedRows([]);
                        setInitialValues({
                          type: 'none',
                          windowCode: '',
                          description: '',
                          viewOnly: false,
                          header: '',
                          indicator: '',
                          windowOwner: '',
                          jsonValidator: '',
                          createdFor: {userLoginName: user?.userName},
                          category: '',
                        });
                      } else {
                        setDeletedRules([]);
                        setReset(!reset);
                      }
                    }}
                  >
                    Reset
                  </Button>
                  <Tooltip
                    // changing title based on copy, edit or new window operation (2699242124)
                    title={selectedRows?.length === 0 ? 'Add fields to save window' : ''}
                  >
                    <div>
                      <Button
                        // disabling based on copy, edit or new window operation or doesn't have access to delete (2699242124)
                        disabled={
                          selectedRows?.length === 0 ||
                          (customWindowData?.windowId &&
                            !isCopyRowData &&
                            !roleData?.window?.['Custom Window Setup']?.CWS?.edit) ||
                          enabledSubmission
                        }
                        variant="outlined"
                        className={`search-btn ${classes.buttonRoot}`}
                        type="submit"
                      >
                        <span>Save</span>
                      </Button>
                    </div>
                  </Tooltip>
                </div>

                <DialogBox
                  hideBackdrop={true}
                  open={mapFiledsDialog}
                  dialogClose={handleClose}
                  // title="Search Repository Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Repository Fields</b>
                      </p>
                      <BreadCrums
                        name={'Window Name'}
                        code={values?.header}
                        description={'Window Description'}
                        descriptionValue={values.description}
                      />
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchDataRepositoryFields
                    handleClose={handleClose}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    formValues={initialValues}
                    baseValue={baseValue}
                    mapFields={true}
                    setCustomWindowFieldValue={setFieldValue}
                    tempSelectedRows={tempSelectedRows}
                    setTempSelectedRows={setTempSelectedRows}
                    refValues={formRef?.current?.values}
                    deletedRules={deletedRules}
                    setDeletedRules={setDeletedRules}
                  />
                </DialogBox>
                <DialogBox
                  open={logicFieldsOpen}
                  dialogClose={handleLogicFieldsClose}
                  // title="Search Data Calculations Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Data Calculations Fields</b>
                      </p>
                      <BreadCrums
                        name={'Window Name'}
                        code={values?.header}
                        description={'Window Description'}
                        descriptionValue={values.description}
                      />
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchLogicField
                    setAuditFieldValue={setSelectedRows}
                    dmValues={selectedRows}
                    setTempSelectedRows={setTempSelectedRows}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleLogicFieldsClose}
                    dmRecordCategory={baseValue}
                    // deletedProcessorFields={fieldsDeleteIdsRef}
                    isRecordFormat={false}
                    isTriggerMaintenance={false}
                    isCustomWindow={true}
                    setCustomWindowFieldValue={setFieldValue}
                    refValues={formRef?.current?.values}
                    deletedRules={deletedRules}
                    setDeletedRules={setDeletedRules}
                  />
                </DialogBox>
                <PreviewFileDialog
                  open={configOpen}
                  dialogClose={handleConfigClose}
                  fileUrl={configurationUrl}
                  configData={configData}
                  dockey={dockey}
                  moduleName={'Custom Windows'}
                  name={'Window Name'}
                  code={values?.header}
                  description={'Window Description'}
                  descriptionValue={values.description}
                />
              </form>
              <DialogBox
                open={saveOpen && (roleAccess || isCopyRowData)}
                title="Warning !"
                maxWidth="sm"
              >
                <DialogeSuccesMsg
                  handleSaveClose={handleSaveClose}
                  setValue={setValue}
                  roleAccess={roleAccess}
                  isCopyRowData={isCopyRowData}
                />
              </DialogBox>
            </div>
          );
        }}
      </Formik>
      {isLoadingPrint && <PageLoader />}
      {(lookupUDWerrorMsg || errorMsg) && (
        <ErrorSnackbar errorMsg={lookupUDWerrorMsg || errorMsg} />
      )}
      {(successMsg || deleteSuccess) && (
        <SuccessSnackbar successMsg={deleteSuccess || successMsg} />
      )}
    </>
  );
};

export default MaintainUserDefined;
